import { defineStore } from "pinia";

export default defineStore('admin', {
  state: () => ({
    customers: [],
    users: [],
    user: [],
    plans: [],
    customer: {
      name: "Select a customer...", // on page load this will be a label.
      plan: {
        id: -1, // by default, select nothing.
      },
    },
  }),
  getters: {
    plan: () => {
      if (this.customer) {
        return this.customer.plan;
      }
      return null;
    },
  },
  actions: {
    async fetchCustomers() {
      try {
        const { data: { data } } = await axios.get("/api/v1/admin/customer?per_page=1000");
        if (data) {
          this.customers = data; // data.data.data
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    async fetchUsers() {
      try {
        const url = new URL('/api/v1/customer/users');
        if (this.customer?.slug) {
          url.searchParams.append('slug', this.customer.slug);
        }
        const response = await axios.get(url.href);
        if (response.data) {
          this.users = response.data.data;
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    async fetchPlans() {
      try {
        const response = await axios.get("/admin/plans");
        if (response.data) {
          this.plans = response.data;
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
  },
});
